import { Controller } from "@hotwired/stimulus"

// Filtrowanie integracji wg kategorii (pills) na stronie /account/apps.
// Gdy wybrana "all", pokazuje wszystkie sekcje kategorii.
// Gdy wybrana "installed", pokazuje tylko zainstalowane karty (i sekcje, w których jakaś jest).
// Gdy wybrana konkretna kategoria, pokazuje tylko tę sekcję.
export default class extends Controller {
  static targets = ["pill", "section", "card"]

  connect() {
    this.currentCategory = "all"
  }

  select(event) {
    const category = event.currentTarget.dataset.category
    this.currentCategory = category
    const installedOnly = category === "installed"

    this.pillTargets.forEach(pill => {
      pill.setAttribute("aria-selected", pill.dataset.category === category)
    })

    this.cardTargets.forEach(card => {
      card.classList.toggle("hidden", installedOnly && card.dataset.installed !== "true")
    })

    this.sectionTargets.forEach(section => {
      let show
      if (category === "all") {
        show = true
      } else if (installedOnly) {
        show = section.querySelector("[data-appstore-category-target=\"card\"][data-installed=\"true\"]") !== null
      } else {
        show = section.dataset.category === category
      }
      section.classList.toggle("hidden", !show)
    })
  }
}
